export class PostCodeAutofill {
  public Address: string;
  public ID: string;
  public URL: string;

  constructor(Address: string,ID: string,URL: string) {
    this.Address = Address;
    this.ID = ID;
    this.URL = URL;
  }

}
